import { useNavigate } from 'react-router-dom';
import { CallUsTemplate } from '.';
import { RoutesList } from '@animal-nuisance/routes/Routes';

const ContentBody = () => (
  <div className="text-bodyLg flex flex-col gap-4">
    <p>If you have found a stray dog that needs collecting, please call us. </p>
    <div>
      <p>
        <strong>By phone</strong>: 0333 577 5070
      </p>
      <p>24-hour service.</p>
      <p>Standard call charges apply.</p>
    </div>
  </div>
);

export const CallUsPage = () => {
  const navigate = useNavigate();
  const title = 'Call us for immediate assistance';
  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.REPORT_TYPE);
    },
  };

  const buttonNext = {
    label: 'Back to homepage',
    onClick: () => {
      window.location.href = 'https://www.westminster.gov.uk/report-it';
    },
  };

  return (
    <CallUsTemplate
      title={title}
      contentBody={<ContentBody />}
      callButton={{
        label: 'Call us',
        href: 'tel:0333 577 5070',
      }}
      buttonPrevious={buttonPrevious}
      buttonNext={buttonNext}
    />
  );
};
